import { Account } from '@/domain/usecases'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import ContentLoader from '../content/content-loader/content-loader'

export default class DependentContentLoader extends ContentLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, queryClient, ldClient)
  }
}
